const listings = [
  {
    "id": "27504",
    "listedDate": "7/30/2025",
    "availableDate": "7/15/2025",
    "unit": "82 W Falls Rd, TN 38109 - Unit 1",
    "beds": "3 Bed",
    "baths": "2 Bath",
    "size": "1109",
    "rent": 1350.0,
    "thumbnail": "https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=086e12214c4b4bfaa444c74a8f64cf6f_406x539.jpeg&isPreview=true",
    "images": [
  "https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=417d29777cbc462bb4a833aa036aba85.jpeg",
  "https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=4b2bd6f472d14e5f94bc36d6b438677e.jpeg",
"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=f9d5fefbb75a4543b72613f9498db341.jpeg",

"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=de2ec2d438fe4f418bf98b46e19ecae4.jpeg",




]

  },
  {
    "id": "30975",
    "listedDate": "7/24/2025",
    "availableDate": "8/15/2025",
    "unit": "2825 Sonora Drive - Unit 1",
    "beds": "2 Bed",
    "baths": "2 Bath",
    "size": "960",
    "rent": 1200.0,
    "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=a85fe6ffa60042fe961cef473b0770fb_406x539.png&isPreview=true"
  },
  {
    "id": "60673",
    "listedDate": "7/24/2025",
    "availableDate": "8/15/2025",
    "unit": "1497 South McLean Boulevard - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "0",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=0874cab310e24d419f0c1490fa48245a_406x539.jpeg&isPreview=true"

  },
  {
    "id": "33773",
    "listedDate": "6/24/2025",
    "availableDate": "7/15/2025",
    "unit": "808 Josephine Street - Unit 1",
    "beds": "3 Bed",
    "baths": "1 Bath",
    "size": "1120",
    "rent": 1450.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=9421fcee3d9a4de7804ddfe07cee6a6f_406x539.jpg&isPreview=true"

  },
  {
    "id": "71471",
    "listedDate": "6/24/2025",
    "availableDate": "7/15/2025",
    "unit": "1328 Lambert Street - Unit 1",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "0",
    "rent": 1050.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=d0e1d32540bb46bda5f240826fbe26cb_406x539.jpeg&isPreview=true"

  },
  {
    "id": "68556",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "840 Freeman Street - Unit 1",
    "beds": "3 Bed",
    "baths": "1 Bath",
    "size": "1269",
    "rent": 1395.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=1c76824ef5604425a7dcb48bb07eb087_406x539.jpeg&isPreview=true"

  },
  {
    "id": "36163",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "818 Laurel Street - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "1350",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=d7d1df56d56a41df9e72acbc4b3cd6f8_406x539.jpg&isPreview=true"

  },
  {
    "id": "36133",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "862 Marianna Street - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "1050",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=c1539573b17845298661d6169d1a422b_406x539.jpg&isPreview=true"

  },
  {
    "id": "53046",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "860 Inez Street - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "1181",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=5a28276e78114076aec649434978c755_406x539.jpg&isPreview=true"

  },
  {
    "id": "60429",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "797 Buntyn Street - Unit 1",
    "beds": "4 Bed",
    "baths": "1 Bath",
    "size": "0",
    "rent": 1425.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=f3eaf9060e614f2f9e84fff81898245e_406x539.jpeg&isPreview=true"

  },
  {
    "id": "35085",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "1320 Bruce Street - Unit 1",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "650",
    "rent": 950.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=b77bd2e4021a414f9e585c6e847393e6_406x539.jpg&isPreview=true"

  },
  {
    "id": "35084",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "1318 Bruce Street - Unit 1",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "650",
    "rent": 950.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=b77bd2e4021a414f9e585c6e847393e6_406x539.jpg&isPreview=true"

  },
  {
    "id": "40035",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "2363 Shasta Avenue - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "1400",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=ea6eeeba983a4453904382a381a8f8f0_406x539.jpg&isPreview=true"

  },
  {
    "id": "69722",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "1850 Davis Circle - Unit 1",
    "beds": "4 Bed",
    "baths": "2 Bath",
    "size": "828",
    "rent": 1550.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=81ce124824a74d79b0cbced716b57033_406x539.jpeg&isPreview=true"

  },
  {
    "id": "70590",
    "listedDate": "6/10/2025",
    "availableDate": "6/15/2025",
    "unit": "1262 Latham Street - Unit 1",
    "beds": "3 Bed",
    "baths": "2 Bath",
    "size": "1048",
    "rent": 1200.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=562e87856dd94582a109824ed98c6d0d_406x539.jpeg&isPreview=true"

  },
  {
    "id": "20841",
    "listedDate": "6/6/2025",
    "availableDate": "6/30/2025",
    "unit": "5366 Clinchport Circle - Unit 1",
    "beds": "3 Bed",
    "baths": "1 Bath",
    "size": "1100",
    "rent": 1350.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=39272b1f0e774c66b34d7aab280a6de4_406x539.jpeg&isPreview=true"

  },
  {
    "id": "24966",
    "listedDate": "6/5/2025",
    "availableDate": "6/15/2025",
    "unit": "193 West Street - Unit 1",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "700",
    "rent": 1250.0,
    "thumbnail": "https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=282dbe37bf9c4e83ab0a75e03b950043_406x539.jpeg&isPreview=true"

  },
  {
    "id": "21578",
    "listedDate": "5/27/2025",
    "availableDate": "6/15/2025",
    "unit": "1589 Jackson Avenue - Unit 1589 West",
    "beds": "1 Bed",
    "baths": "1 Bath",
    "size": "0",
    "rent": 1000.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=3d440477f20e4e52ba4e3d1e0693246d_406x539.jpeg&isPreview=true"

  },
  {
    "id": "29113",
    "listedDate": "5/27/2025",
    "availableDate": "6/15/2025",
    "unit": "760 Richmond Avenue - Unit 4",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "700",
    "rent": 950.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=925c08e3f86f46398360093af933c878_406x539.jpg&isPreview=true"

  },
  {
    "id": "30923",
    "listedDate": "5/27/2025",
    "availableDate": "6/15/2025",
    "unit": "760 Richmond Avenue - Unit 1",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "700",
    "rent": 950.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=d7bbe96bc43f4523b3792ba316b1c1f9_406x539.jpeg&isPreview=true"

  },
  {
    "id": "32937",
    "listedDate": "5/27/2025",
    "availableDate": "6/15/2025",
    "unit": "760 Richmond Avenue - Unit 3",
    "beds": "2 Bed",
    "baths": "1 Bath",
    "size": "700",
    "rent": 950.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=925c08e3f86f46398360093af933c878_406x539.jpg&isPreview=true"

  },
  {
    "id": "62762",
    "listedDate": "5/27/2025",
    "availableDate": "6/15/2025",
    "unit": "3718 Skylark Drive - Unit 1",
    "beds": "3 Bed",
    "baths": "1 Bath",
    "size": "0",
    "rent": 1295.0,
        "thumbnail":"https://memphispassive.managebuilding.com/Resident/api/public/files/download?fileName=219f363264724598a9c1c6ed7360e6ba_406x539.jpeg&isPreview=true"

  }
];

export default listings;